// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FleetsAreaId } from './FleetsAreaId'
import {
  FleetsAreaNavigation,
  FleetsAreaNavigationIcon,
} from './FleetsAreaNavigation'
import { FleetsAreaRoutes } from './FleetsAreaRoutes'

const LazyFleetsComponent = lazy(() => import('./FleetsArea'))

const FleetsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetsComponent />
  </SuspenseLoadingWrapper>
)

export const FleetsArea = {
  id: FleetsAreaId,
  requiredRight: BoumRight.AREA_FLEETS,
  Icon: FleetsAreaNavigationIcon,
  NavigationComponent: FleetsAreaNavigation,
  route: {
    path: FleetsAreaRoutes.route,
    component: FleetsComponent,
  },
}
